/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { showEmployeeByOid } from "../../../redux/actions";
import { responseEmployee } from "../../../redux/reducers";
import FormComponent from "./FormComponent";
import TabComponent from "./TabComponent";
import "./style.scss";
import { convertDateTime } from "../../../utils/date-time";
import { useAuth } from "../../../contexts/auth";

export default function Timesheet() {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { employee } = useSelector(responseEmployee);
  React.useEffect(() => {
    dispatch(showEmployeeByOid(user.EmployeeOid));
  }, [dispatch]);
  return (
    <div>
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>Timesheet</div>
        </div>
        <div className={"breadcrumb-right"}>
          {/* <Link to="/employee-detail" className={"breadcrumb-item"}>
          Timesheet
          </Link> */}
          <span className={"breadcrumb-item active"}>
            Timesheet Information
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-heading has-page-title"}>
          <h4 className={"page-title d-flex align-item-center"}>
            <img
              src={
                employee.AvatarImage
                  ? employee.AvatarImage
                  : "/assets/images/avatar-2.png"
              }
              alt=""
              width={"50px"}
              className="mr-2"
            />
            <span>
              {employee.FullName} - {employee.EmployeeCode}
            </span>
          </h4>
        </div>
        <div className={"section-body"}>
          {employee.Department && employee.Position && (
            <div>
              <FormComponent
                convertDateTime={convertDateTime}
                employee={employee}
              />
              <TabComponent
                convertDateTime={convertDateTime}
                employee={employee}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
